import { AnimatePresence, motion } from 'framer-motion';
import React, { SetStateAction, useEffect, useRef, useState } from 'react';
import style from "./common.module.scss"
import { modalVariants } from './aiAgents/framerAnimations';
import aiAgentsEmptyIcon from '../../../assets/svg/ai-agents/agent-modal-empty.svg'
import disableTick from "../../../assets/svg/ai-agents/Vector (2).svg"
import enableTick from "../../../assets/svg/ai-agents/Vector (3).svg"
import { Input, Icon } from "antd";
import { Http } from "../../../helpers/axois"
import CloseBtn from "../../../assets/svg/ai-agents/closebtn.svg"
import { ActionDetails } from '../Solo/soloJourney/create';
import moduleStyle from "../common/aiAgents/style.module.scss";
import { createColorPicker } from './aiAgents/helpers';

type ActionModalProps = {
    visible: boolean
    setVisible: React.Dispatch<SetStateAction<boolean>>
    branchId: string
    versionId: string
    appId: string
    serviceId?: string
    updateTaskKey?: (id: string, key: string, service?: boolean, params?: Record<string, any>, integrationName?: string, isExternalAgent?: boolean) => void
    setActionDetails: React.Dispatch<SetStateAction<Partial<ActionDetails>>>
    actionDetails: Partial<ActionDetails>
};

type FunctionAction = {
    integration_name: string
    name: string
    description: string
    parameters?: {
        additionalProperties: boolean
        type: string
        required: string[],
        properties: Record<string, { description: string, type: string }>
    }
}

export type ActionList = {
    id?: string,
    type?: string,
    function: FunctionAction
    selectedActionName?: string
}

const ActionModal: React.FC<ActionModalProps> = ({ visible, setVisible, actionDetails, setActionDetails, branchId, versionId, appId, updateTaskKey, serviceId }) => {

    const modalRef = useRef(null);
    const [searchValue, setSearchValue] = useState<string>("");
    const [actionList, setActionList] = useState<ActionList[]>([]);
    const [selectedAction, setSelectedAction] = useState<Partial<ActionList>>({})
    const [loading, setLoading] = useState(false)

    const getActionsLists = () => {
        setLoading(true)
        Http.get(`/apps/${appId}/actions?branchId=${branchId}&versionId=${versionId}`).subscribe((res: any) => {
            setActionList(res || [])
            setLoading(false)
        }, (err) => {
            console.log({ err })
            setLoading(false)
        })
    }

    useEffect(() => {
        getActionsLists()
    }, [])

    const filteredActionList = actionList?.filter((action) => {
        const func = action.function || {};
        return (
            (func.name ?? "").toLowerCase().includes(searchValue.toLowerCase()) ||
            (func.integration_name ?? "").toLowerCase().includes(searchValue.toLowerCase()) ||
            (func.description ?? "").toLowerCase().includes(searchValue.toLowerCase())
        );
    });

    useEffect(() => {
        if (actionList.length) {
            setActionList((prev: ActionList[]) => {
                const index = prev.findIndex(item => `${item.function.name}${item.function.integration_name}` === `${actionDetails.selectedActionName}`);
                if (index !== -1) {
                    const [item] = prev.splice(index, 1);
                    prev.unshift(item);
                }
                return prev;
            })
        }
    }, [actionList])

    return (
        <>
            <AnimatePresence>
                <div className={style.modalOverlay}>
                    <motion.div
                        className={style.modalContent}
                        ref={modalRef}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        variants={modalVariants}
                    >
                        <div className={style.modalHeader}>
                            <p className={style.modalHeaderTitle}>Actions</p>
                            <img alt="close-btn" style={{ cursor: "pointer", width: "15px", height: "15px", marginRight: "9px" }} src={CloseBtn} onClick={() => { setVisible(false); setSelectedAction({}); setActionDetails({}) }} />
                        </div>

                        {<div style={{ padding: 15 }}>
                            <Input value={searchValue}
                                className="prompt-gallery-search"
                                prefix={<Icon type="search" />}
                                onChange={(e) => { setSearchValue(e.target.value) }}
                                placeholder="Search actions"
                            />
                        </div>}
                        {<div className={style.agentListContainer} style={{ overflow: "auto", height: 420, cursor: "pointer", display: actionList?.length === 0 ? "flex" : "grid" }}>
                            {(loading && !actionList?.length) ? <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '20px' }}><div className={moduleStyle.spinner}></div></div> : <></>}
                            {(actionList?.length === 0 && !loading) ?
                                <div className={style.aiAgentsEmptyContainer}>
                                    <img src={aiAgentsEmptyIcon} alt="empty-agents" />
                                    <h1 style={{ color: "#000000", fontWeight: 700, fontSize: 16, margin: "30px 0px 20px 0px" }}>No Actions Created</h1>
                                    <div style={{ width: 330, textAlign: "center", color: "#292D32", fontSize: 14 }}>It seems no actions have been created yet.</div>
                                </div> : null
                            }
                            {(() => {
                                const cardColor = createColorPicker();
                                return actionList?.length ? filteredActionList.map((action, index) => {
                                    const { function: actionFunc } = action;
                                    const { function: selectedActionFunc } = selectedAction;
                                    const isSelectedAction = selectedActionFunc ? `${selectedActionFunc?.name}${selectedActionFunc?.integration_name}` === `${actionFunc.name}${actionFunc.integration_name}` : actionDetails.selectedActionName === `${actionFunc.name}${actionFunc.integration_name}`
                                    return (
                                        <>
                                            <div onClick={() => setSelectedAction(action)} className={`${style.agentCard} ${style.actionCard}`} style={{ 
                                                border: !isSelectedAction ? `1px solid ${cardColor(index).border}` : "1px solid #0466C8", gap: '10px', background: cardColor(index).background }}>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                    <div style={{ display: 'flex', flexDirection: 'column', width: '88%' }}>
                                                        <h2 title={actionFunc.name} className={`${style.agentName} ${style.onelineEllipsis}`}>{actionFunc.name}</h2>
                                                        <div>
                                                            <span style={{ borderRadius: '20px', color: '#222222', background: '#DCEBFF', padding: '2px 5px' }}>{actionFunc.integration_name}</span>
                                                        </div>
                                                    </div>
                                                    <img alt="tick-icons" src={!isSelectedAction ? disableTick : enableTick} />
                                                </div>
                                                <p title={actionFunc.description} style={{ height: '52px', padding: "8px 0px", background: "none" }} className={`${style.agentDesc} ${style.actionDesc}`}>{actionFunc.description}</p>
                                            </div>
                                        </>
                                    )
                                }) : <></>
                            })()}
                        </div>}
                        {actionList?.length > 0 ?
                            <>
                                <div className={style.divider}></div>
                                <div className={style.modalFooter}>
                                    <button className={style.modalFooterBtn} onClick={() => { setVisible(false); setSelectedAction({}); setActionDetails({}) }}>Cancel</button>
                                    <button className={style.modalFooterApplyBtn} style={{ background: "#0466C8", border: "1px solid #0466C8" }} onClick={() => {
                                        setActionDetails({ id: actionDetails.id, ...selectedAction })
                                        if (serviceId) {
                                            updateTaskKey && updateTaskKey(serviceId ?? "", selectedAction?.function?.name || "", true, selectedAction?.function?.parameters?.properties || {}, selectedAction?.function?.integration_name || "")
                                        }
                                        setVisible(false)
                                    }}>Submit</button>
                                </div>
                            </> : <></>}
                    </motion.div>
                </div>
            </AnimatePresence>
        </>
    );
};

export default ActionModal;
